import React, { useState } from 'react';
import {
  Fab, Menu, MenuItem, Typography,
} from '@mui/material';
import { ColorLens } from '@mui/icons-material';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';

interface ISignatureMenu {
  signature: any;
}

export const SignatureMenu = ({ signature }: ISignatureMenu) => {
  const [drawMenu, setDrawMenu] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setDrawMenu(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setDrawMenu(false);
  };

  return (
    <>
      <Fab color='primary' size='large' onClick={handleClick}>
        <ColorLens />
      </Fab>
      <Menu
        anchorEl={anchorEl}
        open={drawMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
      >
        <MenuItem onClick={() => signature.eraseAll()}>
          <DeleteIcon />
          <Typography variant='subtitle1'> Apagar tudo</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
